import React, {useState, useEffect} from "react";
import axios from "axios";
import { HeadersAuth } from "../funciones_utiles";
import { Row, Col, Button, Modal } from "antd";
import { SelectCustom } from "./selectComponent";
import { manejarError } from "../manejo_errores";
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content";

export const ModalDesasignar = ({
  open,
  onClose,
  id_asociacion,
  manejarAlertas
}) => {
  const MySwal = withReactContent(Swal);
  const [desAdmin, setDesAdmin] = useState([]);
  const [tempDatosFormulario, setTempDatosFormulario] = useState({});
  // console.log("id", id_asociacion)
  useEffect(() => {
    if (id_asociacion !== null) {
      fetchAdminesAsignados();
    } 
  }, [id_asociacion, open, onClose])

  useEffect(() => {
    setTempDatosFormulario({
      id: ""
    })
  }, [onClose])

  const fetchAdminesAsignados = async () => {
    try { 
      const idAsociacion = parseInt(id_asociacion)
      const response = await axios.get(
      `${process.env.REACT_APP_DOMINIO}/admin-asociacion/${idAsociacion}`,
      HeadersAuth
      );
      // console.log("asignados", response.data)
      const opcionesFormateadas = response.data.map((a) => ({
        ...a,
        adminCompleto: `${a.nombre} ${a.apellido}`
      }));
      setDesAdmin(opcionesFormateadas)
    } catch (error) {
      console.error("Error al obtener administradores asignados:", error);
    }
  };
  // console.log("temp", tempDatosFormulario)
  const desasignarAdmin = async () => {
		try {
      const idAsociacion = parseInt(id_asociacion)

		  const response = await axios.post(
			`${process.env.REACT_APP_DOMINIO}/admin-asociacion/desasignar`,
			{ asociacion_id: idAsociacion, admin_id: tempDatosFormulario.id },
			HeadersAuth
		  );
	  
		  if (response.status == 200) {
        setTempDatosFormulario({
          id: ""
        })
        MySwal.fire({
          text: "Administrador desasignado",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(() => {
          fetchAdminesAsignados();
        })
      }

		} catch (error) {
		  manejarAlertas("error", manejarError(error));
		}
	};

  const handleChange = (e) => {
		const { id, value } = e.target;
		setTempDatosFormulario((prev) => ({
			...prev,
			[id]: value,
		}));
	};

  return (
    <Modal
      title="Desasignar Administrador"
      open={open}
      onCancel={onClose}
      width={800}
      footer={null}
    >
      {desAdmin.length > 0 ? (
        <Row gutter={0}
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            borderRadius: 5,
            justifyContent: "space-between",
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            padding: 15,
            marginBottom: 10,
            gap: 10,
          }}
        >
          <Col xs={24} sm={14}>
            <SelectCustom
              idCampo={"id"}
              nombreCampo={"Administradores"}
              elPlaceholder={"Seleccioná un administrador"}
              arrayOpciones={desAdmin.length > 0 ? desAdmin : []}
              textoOpciones={"adminCompleto"}
              required={true}
              onChange={handleChange}
              elValue={tempDatosFormulario.id || ""}
            />
          </Col>
          <Col xs={24} sm={8}>
            <Button
              className="boton-principal"
              style={{ fontSize: 16, width: "100%", marginTop: 20 }}
              onClick={desasignarAdmin}
            >
              Desasignar administrador
            </Button>
          </Col>
        </Row>
      ) : (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 20,
            marginBottom: 10
          }}
        >
          <p style={{ fontSize: "18px", color: "#000", fontFamily: "Roboto Condensed, sans-serif", textAlign: "center" }}>No hay administradores para desasignar en esta asociación.</p>
        </div>
      )}
    </Modal>
  )
}